import { Modal, Button, Collapse } from "antd";

const { Panel } = Collapse;

const MetabaseCodeInfoModal = ({
  isOpen,
  onClose,
  onAdd,
  selectedPosition,
}) => {
  return (
    <Modal
      title={"Metabase Payloads"}
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <div className="mb-4">
        <Collapse>
          {selectedPosition?.metabaseCodes?.map((code, index) => (
            <Panel header={code.performanceCycleName} key={index}>
              <pre style={{ backgroundColor: "#f0f0f0", padding: 8 }}>
                {code.metabaseCode}
              </pre>
            </Panel>
          ))}
        </Collapse>
      </div>
      <Button onClick={onAdd}>Add Metabase Payload</Button>
    </Modal>
  );
};

export default MetabaseCodeInfoModal;
